import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"

class LookupService {
    async getStates(): Promise<{ id: string; name: string }[]> {
        const res = await apiClient.get("/lookup/states")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch states")
        }
        return res.data as { id: string; name: string }[]
    }

    async getEducationLevels(): Promise<{ id: string; name: string }[]> {
        const res = await apiClient.get("/lookup/education-levels")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch education levels")
        }
        return res.data as { id: string; name: string }[]
    }

    async getAllowedVacancyPromptLength(): Promise<{ id: string; code: string, name: string } | null> {
        const res = await apiClient.get("/lookup/vacancy-prompt-length")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch vacancy prompt length")
        }
        return (res.data as { id: string; code: string, name: string }) ?? null
    }

    async getVacancyMaxLengths(): Promise<{ titleMaxLength: number; descriptionMaxLength: number }> {
        const res = await apiClient.get("/lookup/vacancy-max-lengths")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch vacancy max lengths")
        }
        return res.data as { titleMaxLength: number; descriptionMaxLength: number }
    }
}

export const lookupService = new LookupService()

export function useLookupService() {
    return lookupService
}
